import axios from 'axios';
import { loadingController } from '../../../../packages/common/src/context/LoadingContext';

let globalNavigate = null;
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error) => {
  failedQueue.forEach((p) => (error ? p.reject(error) : p.resolve()));
  failedQueue = [];
};

export const setGlobalNavigate = (navigateFunc) => {
  globalNavigate = navigateFunc;
};

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080/api/v1',
  withCredentials: true,
});

instance.interceptors.request.use((config) => {
  if (!config.skipLoading) loadingController.show();
  return config;
});

instance.interceptors.response.use(
  (response) => {
    const serverVersion = response.headers['x-app-version'];
    const clientVersion = sessionStorage.getItem('appVersion');

    if (serverVersion) {
      if (clientVersion && clientVersion !== serverVersion) {
        window.__triggerStalePage?.();
      }
      sessionStorage.setItem('appVersion', serverVersion);
    }

    if (!response.config.skipLoading) loadingController.hide();
    return response;
  },
  async (error) => {
    const originalRequest = error.config || {};
    if (!originalRequest.skipLoading) loadingController.hide();

    const statusCode = error.response?.status;

    if (statusCode === 401) {
      if (originalRequest.skipAuthRefresh) return Promise.reject(error);
      if (!window.__isLoggedIn) return Promise.reject(error);

      if (originalRequest._retry) {
        if (globalNavigate) globalNavigate('/session-expired');
        else window.location.href = '/session-expired';
        return Promise.reject(error);
      }

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(() => instance(originalRequest));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        await instance.post('/users/reissue', null, {
          skipAuthRefresh: true,
          skipLoading: true,
        });
        processQueue(null);
        return instance(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError);
        if (globalNavigate) globalNavigate('/session-expired');
        else window.location.href = '/session-expired';
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    if (statusCode === 403) {
      return Promise.reject(error);
    }

    // 호출부가 직접 에러를 처리하는 요청은 전역 에러 페이지로 보내지 않는다
    if (originalRequest.skipGlobalError) {
      return Promise.reject(error);
    }

    if (statusCode >= 500) {
      sessionStorage.setItem(
        'errorFrom',
        window.location.pathname + window.location.search,
      );
      if (globalNavigate) globalNavigate(`/error?code=${statusCode}`);
      return Promise.reject(error);
    }

    if (statusCode >= 400) {
      if ((originalRequest.url || '').includes('/users/login')) {
        return Promise.reject(error);
      }
      sessionStorage.setItem(
        'errorFrom',
        window.location.pathname + window.location.search,
      );
      if (globalNavigate) globalNavigate(`/error?code=${statusCode}`);
      return Promise.reject(error);
    }

    return Promise.reject(error);
  },
);

export default instance;
